module.exports = __webpack_public_path__ + "media/PAG65-08.a1a75dc0.mp3";